/**
 * Мини-роутер на хэше. Четыре экрана, зависимостей ноль.
 *
 * React Router здесь не нужен — и это не экономия ради экономии. Админка
 * выкатывается как статика на Render без сервера, а хэш-маршруты не требуют
 * ни правил rewrite, ни `_redirects`: любой URL отдаёт тот же index.html,
 * и глубокая ссылка на карточку игрока переживает F5 сама. Полноценный
 * роутер приедет на E10 вместе с двумя десятками разделов, если понадобится.
 */

import { useEffect, useState } from 'react'

export type Route =
  | { name: 'economy' }
  | { name: 'scenes' }
  | { name: 'players' }
  | { name: 'player'; id: string }
  | { name: 'cheats' }
  | { name: 'generation' }

export const DEFAULT_ROUTE: Route = { name: 'economy' }

export function parseHash(hash: string): Route {
  const path = hash.replace(/^#\/?/, '').split('?')[0] ?? ''
  const parts = path.split('/').filter((p) => p.length > 0)

  if (parts[0] === 'players') {
    const id = parts[1]
    return id === undefined ? { name: 'players' } : { name: 'player', id: decodeURIComponent(id) }
  }
  if (parts[0] === 'scenes') return { name: 'scenes' }
  if (parts[0] === 'cheats') return { name: 'cheats' }
  if (parts[0] === 'generation') return { name: 'generation' }
  return DEFAULT_ROUTE
}

export function hrefFor(route: Route): string {
  switch (route.name) {
    case 'economy':
      return '#/economy'
    case 'scenes':
      return '#/scenes'
    case 'players':
      return '#/players'
    case 'player':
      return `#/players/${encodeURIComponent(route.id)}`
    case 'cheats':
      return '#/cheats'
    case 'generation':
      return '#/generation'
  }
}

export function navigate(route: Route): void {
  window.location.hash = hrefFor(route)
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => parseHash(window.location.hash))

  useEffect(() => {
    const onChange = (): void => setRoute(parseHash(window.location.hash))
    window.addEventListener('hashchange', onChange)
    return () => window.removeEventListener('hashchange', onChange)
  }, [])

  return route
}
